import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Close } from '@material-ui/icons'
import { Alert, CleanButton, Label, Loader, PrimaryButton, SelectField } from '../default'
import { Box, Grid, IconButton, Modal, Paper, Tooltip, withStyles } from '@material-ui/core'
import { connect, useDispatch } from 'react-redux'
import { acClearUpdateCustomerData, acGetProductTables, acPutUpdateCustomer } from '../../class/actions'


function CustomerProductTableModal({
  classes, open, onClose, onRefresh,
  currentCustomer,
  productTablesError, loadingProductTables, productTables,
  updatingCustomer, errorUpdateCustomer, successUpdateCustomer
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [selectedProductTable, setSelectedProductTable] = useState('')

  useEffect(() => {
    if (currentCustomer && currentCustomer.product_table_id && !selectedProductTable)
      setSelectedProductTable(currentCustomer.product_table_id)
  }, [currentCustomer, selectedProductTable])

  useEffect(() => {
    if (!updatingCustomer && !errorUpdateCustomer && successUpdateCustomer) {
      dispatch(acClearUpdateCustomerData())
      onRefresh()
    }
  }, [dispatch, onRefresh, updatingCustomer, errorUpdateCustomer, successUpdateCustomer])

  useEffect(() => {
    dispatch(acGetProductTables())
  }, [dispatch])

  const moveCustomerProductTable = () => {
    dispatch(acPutUpdateCustomer(currentCustomer.id, {
      product_table_id: selectedProductTable
    }))
  }

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0 }}>
      <Paper
        square={true}
        className={classes.root + ' ' + classes.modalDiv}
      >
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Grid container spacing={2} className={classes.grid}>
            <Grid item xs={8}>
              <Label v='h6'>
                {t('modals.productTable.move.title')}
              </Label>
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'right', padding: 0 }}>
              <Tooltip title={t('default.close')}>
                <IconButton onClick={onClose}>
                  <Close />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xd={12}>
              <Label>
                {t('modals.productTable.move.caption')}
              </Label>
            </Grid>
            <Grid item xs={12}>
              {
                loadingProductTables ?
                  <Loader /> :
                  productTablesError ?
                    <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={productTablesError.description ? productTablesError.description : t('modals.productTable.move.unknownError')} /> :
                    <SelectField id='select-customer-product-table'
                      label={t('modals.productTable.move.productTable')}
                      items={productTables.map(productTable => ({
                        name: productTable.name,
                        value: productTable.product_table_id
                      }))}
                      value={selectedProductTable}
                      onChange={e => setSelectedProductTable(e.target.value)} />
              }
            </Grid>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <CleanButton onClick={onClose} style={{ marginRight: '15px' }}>
                {t('default.cancel')}
              </CleanButton>
              <PrimaryButton onClick={moveCustomerProductTable}>
                {
                  updatingCustomer ? (
                    <Loader />
                  ) : (
                    <div>
                      {t('modals.productTable.move.action')}
                    </div>
                  )
                }
              </PrimaryButton>
            </Grid>
            {
              errorUpdateCustomer &&
              <Grid item xs={12}>
                <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={errorUpdateCustomer.description ? errorUpdateCustomer.description : t('modals.productTable.move.unknownError')} />
              </Grid>
            }
          </Grid>
        </Box>
      </Paper>
    </Modal >
  )
}

CustomerProductTableModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  close: PropTypes.func
}

CustomerProductTableModal.defaultProps = {
  open: false,
  onClose: () => true,
  close: () => true
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    padding: theme.spacing(2),
    maxHeight: '90%',
    overflowY: 'scroll'
  },
  grid: {
    display: 'flex',
    flex: 1
  },
  modalDiv: {
    [theme.breakpoints.up('md')]: {
      width: '35%'
    },
    width: '100%',
    top: '10%',
    left: '50%',
    transform: 'translate(-50%, -10%)',
  },
})

const mapStateToProps = ({ ReducerProductTable, ReducerCustomer }) => ({
  productTables: ReducerProductTable.productTables,
  productTablesError: ReducerProductTable.productTablesError,
  loadingProductTables: ReducerProductTable.loadingProductTables,

  updatingCustomer: ReducerCustomer.updatingCustomer,
  errorUpdateCustomer: ReducerCustomer.errorUpdateCustomer,
  successUpdateCustomer: ReducerCustomer.successUpdateCustomer
})

export default connect(mapStateToProps)(withStyles(styles)(CustomerProductTableModal))